import React from 'react';

type LoadingStateProps = {
  variant?: 'page' | 'table' | 'inline';
  rows?: number;
  message?: string;
};

const LoadingState: React.FC<LoadingStateProps> = ({
  variant = 'inline',
  rows = 5,
  message,
}) => {
  if (variant === 'page') {
    return (
      <div className="flex flex-col items-center justify-center py-16 gap-3">
        <div className="h-8 w-8 rounded-full border-2 border-scout-green border-t-transparent animate-spin" />
        <p className="text-sm text-slate-500">{message ?? 'Cargando…'}</p>
      </div>
    );
  }

  if (variant === 'table') {
    return (
      <div className="rounded-lg border border-slate-200 bg-white overflow-hidden animate-pulse">
        {Array.from({ length: rows }).map((_, i) => (
          <div
            key={i}
            className="flex gap-3 px-4 py-3 border-b border-slate-100 last:border-0"
          >
            <div className="h-4 bg-slate-200 rounded flex-1 max-w-[80px]" />
            <div className="h-4 bg-slate-200 rounded flex-[2]" />
            <div className="h-4 bg-slate-200 rounded flex-1 max-w-[60px] hidden sm:block" />
          </div>
        ))}
      </div>
    );
  }

  return (
    <p className="text-slate-500 text-sm py-4">{message ?? 'Cargando…'}</p>
  );
};

export default LoadingState;
